"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'hubs/v2/i18n';

var I18nAPI =
/*#__PURE__*/
function () {
  function I18nAPI() {
    (0, _classCallCheck2.default)(this, I18nAPI);
  }

  (0, _createClass2.default)(I18nAPI, null, [{
    key: "getOptions",
    value: function getOptions() {
      return _apiClient.default.get(API_BASE + "/options");
    }
  }, {
    key: "getSetting",
    value: function getSetting() {
      return _apiClient.default.get(API_BASE);
    }
  }, {
    key: "set",
    value: function set(_ref) {
      var language = _ref.language,
          locale = _ref.locale;
      return _apiClient.default.post(API_BASE, {
        data: {
          language: language,
          locale: locale
        }
      });
    }
  }]);
  return I18nAPI;
}();

exports.default = I18nAPI;
module.exports = exports.default;